import React from "react";
import ReactDOM from "react-dom";
import App from "./pages/App";
import "antd/dist/antd.css";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { Router } from "react-router-dom";
import history from "./utils/history";
import "./styles/style.scss";
const root = document.getElementById("root");
ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  root
);
